import "./LocationPage.css";
import Footer from "../../Footer";

export default function LocationPage() {
  const address =
    "서울시 강서구 양천로 583 우림블루나인비즈니스센터 A동 2009호 에이콘 출판사";

  const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
    address
  )}&output=embed`;

  return (
    <div className="location-page">
      <section className="map-section">
        <iframe
          title="에이콘 출판사 위치"
          src={mapUrl}
          className="google-map"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </section>

      <section className="info-section">
        <div className="address-block">
          <h3>주소</h3>

          <p className="address">{address}</p>

          <p>
            <strong>Tel</strong> :{" "}
            <a href="tel:+82226537600">+82-2-2653-7600</a>
          </p>

          <p>
            <strong>Fax</strong> : +82-2-2653-0433
          </p>

          <p>
            <strong>Mail</strong> :{" "}
            <a href="mailto:acornpub@acornpub.co.kr">
              acornpub@acornpub.co.kr
            </a>
          </p>

          <p>
            <strong>SNS</strong> :{" "}
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              Facebook
            </a>
          </p>
        </div>

        <div className="address-block traffic">
          <h3>대중교통 이용시</h3>

          <p>            
            <span className="line-badge">9</span>            
            <strong>증미역 2번 출구 (약 2분 소요)</strong>            
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}